module.exports = __webpack_public_path__ + "static/media/w_w_hw_25.a5d4035e.png";